import Vue from 'vue';
import VueRouter from 'vue-router';
import PublicRoot from '@/pages/root/PublicRoot.vue';
import AdminRoot from '@/pages/root/AdminRoot.vue';
import BrandRoot from '@/pages/root/BrandRoot.vue';
import SuperAdminRoot from '@/pages/root/SuperAdminRoot.vue';
import BudtenderRoot from '@/pages/root/BudtenderRoot.vue';
import PAGES from './common/routes.config';


Vue.use(VueRouter);

const DEFAULT_TITLE = 'Loading...';
const TITLE_SUFFIX = ' | chrncl';

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    // Publicly accessible routes
    {
      path: '/',
      component: PublicRoot,
      children: PAGES.PUBLIC,
    },
    {
      path: '/b',
      component: BrandRoot,
      children: PAGES.BRAND,
    },
    {
      path: '/admin/:brandId',
      component: AdminRoot,
      children: PAGES.ADMIN,
    },
    {
      path: '/budtender',
      component: BudtenderRoot,
      children: PAGES.BUDTENDER,
    },
    {
      path: '/superadmin',
      component: SuperAdminRoot,
      children: PAGES.SUPER_ADMIN,
    },
  ],
});

router.beforeEach((to, _, next) => {
  document.title = to.meta.title + TITLE_SUFFIX || DEFAULT_TITLE;
  next();
});
export default router;
